<template>
	<section class="page page-content-item">
		<ViewContentArticle v-bind:contentModel="contentModel" v-if="contentModel && contentModel.id" />

		<hr v-if="contentModel && contentModel.id" />

		<ChalkyCommentList
			class="padded rounded"
			direction="asc"
			maxHeight="50svh"
			v-bind:model="contentModel"
			v-if="contentModel && contentModel.id"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop, Watch } from 'vue-property-decorator';
	import { mounted } from '@/Utility/Decorators';

	/**
	 * Single content item detail page. Fetches and displays the full
	 * article or video with a comment thread below.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageContentItem extends PageBase {
		/**
		 * Content ID or slug from route params
		 *
		 * @type string
		 */
		@Prop({
			default: '',
		})
		public id!: string;

		/**
		 * Content model for the current item
		 *
		 * @type ChalkySticks.Model.Content
		 */
		protected contentModel: ChalkySticks.Model.Content = ChalkySticks.Factory.Content.model();

		/**
		 * Fetch content model by ID on mount
		 *
		 * @return Promise<void>
		 */
		@mounted
		protected async fetchContent(): Promise<void> {
			if (this.id) {
				this.contentModel.set({ id: this.id });

				await this.contentModel.fetch();
			}
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Refetch content when route ID changes
		 *
		 * @param string newId
		 * @param string oldId
		 * @return Promise<void>
		 */
		@Watch('$route.params.id')
		protected async Handle_OnRouteChange(newId: string, oldId: string): Promise<void> {
			if (newId && newId !== oldId) {
				this.contentModel = ChalkySticks.Factory.Content.model();
				this.contentModel.set({ id: newId });

				await this.contentModel.fetch();

				this.$nextTick(() => this.$el.scrollTo(0, 0));
			}
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	// Layout
	// ---------------------------------------------------------------------------

	.page-content-item {
		background-color: var(--chalky-blue-4);

		hr {
			--divider-color: var(--chalky-grey-4);
			--divider-spacing-y: 30px;
		}

		.back-nav {
			padding: 1rem var(--padding-body);

			a {
				color: var(--chalky-grey);
				font-size: 0.9rem;
				text-decoration: none;
				transition: color 0.2s ease-in-out;

				&:hover {
					color: var(--chalky-white);
				}
			}
		}

		.comment-list {
			margin: 0 auto;
			max-width: 800px;
		}
	}
</style>
